import React, { useEffect, useState } from "react";
import "./styles.scss";
import { InputBox } from "../../../../components";
import { CheckValidity } from "../../../../utils/formValidity";
import draftToHtml from "draftjs-to-html";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { useSelector } from "react-redux";
import htmlToDraft from "html-to-draftjs";

const English = ({ onChange, finish }) => {
  const [formData, setFormData] = useState({
    descriptionEN: {
      key: "descriptionEN",
      label: "Description (EN)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const selectedLiveFeed = useSelector(
    (state) => state.liveFeedReducer.selectedLiveFeed
  );

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const updateNewsForm = {
      ...formData,
      descriptionEN: {
        ...formData.descriptionEN,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    };
    setFormData(updateNewsForm);
  };

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setEditorState(EditorState.createEmpty());
    setFormData(updateNewsForm);
  };

  useEffect(() => {
    onChange(formData);
  }, [formData]);

  useEffect(() => {
    if (finish) {
      clearAll();
    }
  }, [finish]);

  useEffect(() => {
    if (selectedLiveFeed?.news_id) {
      let updateFormData = { ...formData };
      const description = htmlToDraft(selectedLiveFeed?.title["en"]);
      setEditorState(EditorState.createEmpty());

      if (description && description.contentBlocks) {
        const contentState = ContentState.createFromBlockArray(
          description.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      setFormData(updateFormData);
    } else {
      clearAll();
    }
  }, [selectedLiveFeed]);

  const updateNewsForm = { ...formData };

  return (
    <>
      <div className={"english-language-wrapper"}>
        <div className={"rich-text-editor-wrapper"}>
          <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={onEditorStateChange}
            toolbar={{
              fontFamily: {
                options: ["gothambook"],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
              fontSize: {
                icon: undefined,
                options: [11, 12, 13, 14, 18, 24],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
            }}
          />
        </div>
      </div>
    </>
  );
};
export default English;
